import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Radium from 'radium';
import { bindActionCreators } from 'redux';

import {
  searchProfiles as searchProfilesAction,
  setProfileIndex as setProfileIndexAction,
} from "../../../redux/middleware/profile";
import {
  getProfiles,
  getProfilesError,
  getProfilesFilters,
  getProfilesTotal,
} from "../../../redux/reducers/profile";

import { Container, StyledCol, ProfileTitle } from "./Common/profileRowStyles";

class ProfileRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { profile: null };
  }

  onMouseOver = () => {
    const profileIndex = this.props.profiles.indexOf(this.props.profile);
    this.props.setProfileIndex({ profileIndex: profileIndex });
  };

  render() {
    let { profile, subscribed } = this.props;
    return (
      <Container onMouseOver={this.onMouseOver}>
        <StyledCol className="col-lg" xs={10}>
          <ProfileTitle>
            {subscribed ? (
              <React.Fragment>
                <Link to={`/profiles/${profile.slug}`}>
                  {profile.user.fname + " " + profile.user.lname}
                </Link>
                {profile && profile.title && ` - ${profile.title}`}
              </React.Fragment>
            ) : profile && profile.title ? (
              profile.title
            ) : (
              "Software Developer"
            )}
          </ProfileTitle>
          <div className="info">
            {profile.educations &&
              profile.educations.map((education, index) => {
                return (
                  <span
                    key={`education-${index}`}
                    style={{
                      paddingBottom: "60px",
                      color: "rgb(10, 57, 73)",
                    }}
                  >
                    <i
                      className="fa fa-graduation-cap"
                      style={{ color: "rgb(10, 57, 73)" }}
                    ></i>
                    {education.institution}
                  </span>
                );
              })}
            {profile.work_experiences &&
              profile.work_experiences.map((position, index) => {
                return (
                  <div key={`experience-${index}`}>
                    <span style={{ color: "green" }}>
                      <i
                        className="fa fa-briefcase"
                        style={{ color: "green" }}
                      ></i>
                      {position.title}
                    </span>
                    <span style={{ marginLeft: "10px", color: "#0071bc" }}>
                      <i
                        className="fa fa-building"
                        style={{ color: "#0071bc" }}
                      ></i>
                      {position.company}
                    </span>
                  </div>
                );
              })}
          </div>
          <div>
            Last updated: {moment(profile.updated_at).format("MM/DD/YYYY")}
          </div>
        </StyledCol>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profiles: getProfiles(state),
  filters: getProfilesFilters(state),
  totalProfiles: getProfilesTotal(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchProfiles: searchProfilesAction,
      setProfileIndex: setProfileIndexAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Radium(ProfileRow));
